import Button from ".";
import Tooltip from "../Tooltip";

export default function ButtonWithTooltip({children, title, ...props}) {
    return (
        <Tooltip title={title}>
            <Button {...props}>
                {children}
            </Button>
        </Tooltip>
    );
}
